import { DateTime } from "luxon";
import React, { useMemo } from "react";
import { Updater, useImmer } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { usePutTestSchedule } from "../../../../../../api/schedules/put-test-schedule";
import { SimpleDateTimePicker } from "../../../../../../components/DatePickers/SimpleDateTimePicker";

import { PanelProps } from "./types";

interface ScheduleContentProps extends PanelProps {
  setIsScheduling: Updater<boolean>;
}

export const ScheduleContent = ({
  label,
  color,
  setIsScheduling,
  schedule,
  experience,
  action,
  minScheduleTime,
}: ScheduleContentProps) => {
  const [dateTime, setDateTime] = useImmer<DateTime | null>(null);
  const [isDateError, setIsDateError] = useImmer<boolean>(false);
  const putTestSchedule = usePutTestSchedule();

  const onTimeChange = (time: DateTime | null) => {
    setDateTime(time);
  };

  const onSaveClick = () => {
    if (dateTime) {
      putTestSchedule.mutate(
        {
          body: {
            experienceId: experience.id!,
            action,
            executionTime: dateTime.toMillis(),
          },
          queryParams: undefined,
          pathParams: undefined,
        },
        {
          onSettled: () => {
            setIsScheduling(false);
          },
        }
      );
    } else {
      setIsScheduling(false);
    }
  };

  if (!minScheduleTime) {
    return null;
  }

  return (
    <Grid
      container
      justifyContent={"space-between"}
      alignItems={"center"}
      sx={{ height: "100%" }}
    >
      <Grid item>
        <Grid item>
          <IgTypography sx={{ fontWeight: 600 }}>{label} at:</IgTypography>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container item columnSpacing={2} alignItems={"center"}>
          <Grid item>
            <SimpleDateTimePicker
              width={"250px"}
              disabled={putTestSchedule.isPending}
              onTimeChange={onTimeChange}
              resourceMinTime={minScheduleTime}
              minutesStep={5}
              dateTime={dateTime}
              setIsError={setIsDateError}
            />
          </Grid>
          <Grid item>
            <IgButton
              disabled={isDateError}
              color={color}
              variant={"outlined"}
              onClick={() => onSaveClick()}
              loading={putTestSchedule.isPending}
            >
              {dateTime ? "Save" : "Cancel"}
            </IgButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
